import template from './project-declaration-url.jade';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.projectDeclarationUrl', [])
  .directive('cianAfPriceAndDealTermsProjectDeclarationUrl', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        if (!this.ad.bargainTerms) {
          this.ad.bargainTerms = {};
        }

        this.isRequired = () => this.ad.bargainTerms.saleType === 'fz214';

        this.validation = validation(this.form, 'projectDeclarationUrl', {
          required: 'Укажите ссылку на проектную декларацию',
        });
      },
    ],
    controllerAs: 'projectDeclarationUrl',
    template,
  })).name;
